import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { whenPageRevealed } from '@/js/lib/page-reveal.js';

gsap.registerPlugin( ScrollTrigger );

const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

// Editorial reveal: images scale-in + drift, header children fade-up.
// Title regels worden onafhankelijk geanimeerd door lib/highlight-reveal.js
// — die module pakt automatisch alle h1/h2 op de pagina.
function initHeroReveal() {
	const heroes = document.querySelectorAll( '[data-hero-reveal]' );
	if ( ! heroes.length ) {
		return;
	}

	heroes.forEach( ( hero ) => {
		const images   = hero.querySelectorAll( '[data-hero-image]' );
		const children = hero.querySelectorAll( '[data-hero-reveal-child]' );

		if ( ! images.length && ! children.length ) {
			return;
		}

		if ( reduceMotion ) {
			gsap.set( [ ...images, ...children ], {
				opacity:    1,
				scale:      1,
				y:          0,
				clearProps: 'all',
			} );
			return;
		}

		gsap.set( images,   { opacity: 0, scale: 0.92, y: 24 } );
		gsap.set( children, { opacity: 0, y: 16 } );

		const rect         = hero.getBoundingClientRect();
		const isAboveFold  = rect.top < window.innerHeight * 0.5;

		const timelineOpts = {
			defaults: { ease: 'power3.out' },
		};

		if ( isAboveFold ) {
			timelineOpts.delay = 0.15;
		} else {
			timelineOpts.scrollTrigger = {
				trigger: hero,
				start:   'top 90%',
				once:    true,
			};
		}

		const tl = gsap.timeline( timelineOpts );

		if ( images.length ) {
			tl.to( images, {
				opacity:  1,
				scale:    1,
				y:        0,
				duration: 1.1,
				stagger:  0.08,
			}, 0 );
		}

		if ( children.length ) {
			tl.to( children, {
				opacity:  1,
				y:        0,
				duration: 0.7,
				stagger:  0.12,
			}, 0.25 );
		}
	} );
}

function bootstrap() {
	Promise.all( [ document.fonts?.ready, whenPageRevealed() ] ).then( initHeroReveal );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', bootstrap );
} else {
	bootstrap();
}

export { initHeroReveal };
